"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthLedgerSigner = void 0;
const ethers_1 = require("ethers");
class EthLedgerSigner extends ethers_1.ethers.Signer {
    constructor(provider, ledger) {
        super();
        ethers_1.ethers.utils.defineReadOnly(this, "provider", provider);
        this.ledger = ledger;
    }
    connect() {
        // eslint-disable-line class-methods-use-this
        throw new Error("invalid instantiation");
    }
    getAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.ledger.displayAddress;
        });
    }
    parseTx(tx) {
        var _a, _b;
        const { from } = tx, txProps = __rest(tx, ["from"]); // eslint-disable-line @typescript-eslint/no-unused-vars
        return Object.assign(Object.assign({}, txProps), { nonce: parseInt((_b = (_a = tx.nonce) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "0", 10) });
    }
    serializeTx(tx) {
        return ethers_1.ethers.utils.serializeTransaction(this.parseTx(tx));
    }
    sendTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const signature = yield this.signTransaction(transaction);
            const unsignedTx = this.parseTx(transaction);
            const signedTx = ethers_1.ethers.utils.serializeTransaction(unsignedTx, signature);
            const txResponse = this.provider.sendTransaction(signedTx);
            return txResponse;
        });
    }
    signTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = yield ethers_1.ethers.utils.resolveProperties(transaction);
            const unsignedTx = this.serializeTx(tx);
            const bipString = this.ledger.getBIP44Path();
            const signatureResult = yield this.ledger.ethApp.signTransaction(bipString, unsignedTx.substring(2));
            const signature = ethers_1.ethers.utils.joinSignature({
                v: parseInt(signatureResult.v, 16),
                r: `0x${signatureResult.r}`,
                s: `0x${signatureResult.s}`,
            });
            return signature;
        });
    }
    signMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (message.startsWith("0x")) {
                message = message.substring(2); // eslint-disable-line no-param-reassign
            }
            const signature = yield this.ledger.sign(message);
            return signature;
        });
    }
}
exports.EthLedgerSigner = EthLedgerSigner;
